// extracted by mini-css-extract-plugin
export var actionButton = "_jm-0";
export var actionMenuContainer = "_jm-i";
export var bubble = "_jm-2";
export var bubbleActionMenu = "_jm-j";
export var bubbleContext = "_jm-6";
export var bubbleItems = "_jm-7";
export var customer = "_jm-3";
export var divider = "_jm-8";
export var fileList = "_jm-9";
export var hiddenComment = "_jm-o";
export var infoAbove = "_jm-a";
export var internal = "_jm-4";
export var lightActionButton = "_jm-1";
export var link = "_jm-b";
export var merchant = "_jm-5";
export var message = "_jm-c";
export var profilePicture = "_jm-e";
export var quillToolbarContainer = "_jm-f";
export var senderDate = "_jm-g";
export var senderDateCustomer = "_jm-h";
export var senderName = "_jm-d";
export var time = "_jm-k";
export var uploadedImage = "_jm-l";
export var username = "_jm-m";
export var xsmall = "_jm-n";